module.exports = __webpack_public_path__ + "img/gitlab-icon-rgb.0faea8c8.svg";